/*
 * Copyright (c) 2023. Legalbird eine Marke der R+S Internet Jewels GmbH
 */

import Dashboard from "../../Dashboard/Dashboard";

const DashBoardPage = () => {
  return <Dashboard />;
};

export default DashBoardPage;
